import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink} from '@angular/router';

@Component({
  selector: 'app-register-success-page',
  standalone: true,
    imports: [
        RouterLink
    ],
  templateUrl: './register-success-page.component.html',
  styleUrl: './register-success-page.component.scss'
})
export class RegisterSuccessPageComponent implements OnInit{
  email: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(
        (params) => {
            this.email = params.email;
        }
    );
  }
}
